import React from 'react';
import { authProvider } from '../providers/authProvider';

const LoginPage = () => {
  const handleLogin = () => {
    authProvider.login();
  };

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '100vh',
      padding: '20px',
      fontFamily: 'Arial, sans-serif'
    }}>
      <div style={{
        maxWidth: '400px',
        width: '100%',
        padding: '40px',
        border: '1px solid #ddd',
        borderRadius: '8px',
        boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
        textAlign: 'center'
      }}>
        <h1 style={{
          marginBottom: '20px',
          color: '#333',
          fontSize: '28px'
        }}>
          Magtuner Admin
        </h1>
        <p style={{
          marginBottom: '30px',
          color: '#666',
          fontSize: '16px'
        }}>
          Connectez-vous pour accéder à votre compte administrateur
        </p>
        <button
          onClick={handleLogin}
          style={{
            backgroundColor: '#1976d2',
            color: 'white',
            border: 'none',
            padding: '12px 24px',
            fontSize: '16px',
            borderRadius: '4px',
            cursor: 'pointer',
            width: '100%',
            transition: 'background-color 0.3s'
          }}
          onMouseOver={(e) => e.target.style.backgroundColor = '#1565c0'}
          onMouseOut={(e) => e.target.style.backgroundColor = '#1976d2'}
        >
          Se connecter
        </button>
      </div>
    </div>
  );
};

export default LoginPage;
